import { RiskBadge } from '../ui/RiskBadge';
import { timingLabel } from '../../lib/automationLabels';
import type { FlowSummary } from '../../types/org.types';

const RISK_LABEL: Record<FlowSummary['risk'], string> = {
  ok: 'OK',
  migrate: 'Migrate',
  retire: 'Retire',
  inactive: 'Inactive',
  'old-api': 'Old API',
};

export function FlowsTable({ rows }: { rows: FlowSummary[] }) {
  if (rows.length === 0) {
    return <div className="text-sm text-neutral-500 py-6">No flows matched.</div>;
  }
  return (
    <div className="border border-border rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-surface-2">
          <tr className="text-[11px] uppercase tracking-widest text-neutral-500">
            <th className="text-left px-4 py-3 font-medium">Flow</th>
            <th className="text-left px-4 py-3 font-medium">Type</th>
            <th className="text-left px-4 py-3 font-medium">Status</th>
            <th className="text-left px-4 py-3 font-medium">Object</th>
            <th className="text-left px-4 py-3 font-medium">Timing</th>
            <th className="text-left px-4 py-3 font-medium">API</th>
            <th className="text-left px-4 py-3 font-medium">Risk</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((f, i) => (
            <tr
              key={f.id}
              className={i % 2 === 0 ? 'bg-surface-1/40' : 'bg-transparent'}
            >
              <td className="px-4 py-2.5">
                <div className="text-crux-light">{f.label}</div>
                <div className="text-[11px] text-neutral-600 font-mono">{f.apiName}</div>
              </td>
              <td className="px-4 py-2.5 text-neutral-400">{f.processType}</td>
              <td className="px-4 py-2.5 text-neutral-300">{f.status}</td>
              <td className="px-4 py-2.5 text-neutral-400">{f.triggerObject ?? 'No object'}</td>
              <td className="px-4 py-2.5 text-neutral-400">{timingLabel(f.triggerTiming) ?? '-'}</td>
              <td className="px-4 py-2.5 text-neutral-400 tabular-nums">{f.apiVersion ?? '-'}</td>
              <td className="px-4 py-2.5">
                <RiskBadge tone={f.risk === 'ok' ? 'healthy' : f.risk}>{RISK_LABEL[f.risk]}</RiskBadge>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
